var _path, _setting;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTvseries(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vector10",
    width: 144,
    height: 125,
    viewBox: "0 0 144 125",
    fill: "#272731",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      maxWidth: "100%",
      maxHeight: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.25 84H140V4H4.5V84H72.25ZM72.25 84L32 120.5H110L72.25 84ZM52.5 26.5V62.5L84.5 45.5L52.5 26.5Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeDasharray: "725.2962646484375,0,0,0"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: 1,
    dur: "3.5714285714285716s",
    begin: "mouseover",
    from: "0,0,0,725.2962646484375",
    to: "725.2962646484375,0,0,0",
    fill: "freeze"
  }))), _setting || (_setting = /*#__PURE__*/React.createElement("setting", null, "{\"type\":\"direct\",\"speed\":14,\"random\":1,\"shift\":1,\"size\":1,\"rupture\":50}")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvseries);
export default __webpack_public_path__ + "static/media/tvseries.f6c557212e21ac69db88506b03ba3f4f.svg";
export { ForwardRef as ReactComponent };